<template>
  <div class="imageGuideBox hide-scrollbar">
      <span class="close-box" @click="returns"></span>
        <div class="bannerBg">
          <span></span>
        </div>
        <div class="content">
          <div class="gift-box">
            <div class="gift-item">
              <div>
                <img src="../../assets/image_guide/image3/gift1.png" alt="">
              </div>
              <p class="giftName">{{ $t("gift_conf_lv1") }}</p>
              <p>50000</p>
            </div>
            <div class="gift-item">
              <div>
                <img src="../../assets/image_guide/image3/gift2.png" alt="">
              </div>
              <p class="giftName">{{ $t("gift_conf_lv2") }}</p>
              <p>100000</p>
            </div>
            <div class="gift-item">
              <div>
                <img src="../../assets/image_guide/image3/gift3.png" alt="">
              </div>
              <p class="giftName">{{ $t("gift_conf_lv3") }}</p>
              <p>200000</p>
            </div>
            <div class="gift-item">
              <div>
                <img src="../../assets/image_guide/image3/gift4.png" alt="">
              </div>
              <p class="giftName">{{ $t("gift_conf_lv4") }}</p>
              <p>500000</p>
            </div>
            <div class="gift-item">
              <div>
                <img src="../../assets/image_guide/image3/gift5.png" alt="">
              </div>
              <p class="giftName">{{ $t("gift_habibi") }}</p>
              <p>10000</p>
            </div>
            <div class="gift-item">
              <div>
                <img src="../../assets/image_guide/image3/gift6.png" alt="">
              </div>
              <p class="giftName">{{ $t("gift_bestie") }}</p>
              <p>10000</p>
            </div>
            <div class="gift-item">
              <div>
                <img src="../../assets/image_guide/image3/gift7.png" alt="">
              </div>
              <p class="giftName">{{ $t("gift_couple") }}</p>
              <p>50000</p>
            </div>
            <div class="gift-item">
              <div>
                <img src="../../assets/image_guide/image3/gift8.png" alt="">
              </div>
              <p class="giftName">{{ $t("gift_confidant") }}</p>
              <p>50000</p>
            </div>
          </div>
          <p class="gift-desc">{{ $t("gift_album_des2") }}</p>
          <div class="gift-two-box">
            <div>
              <img src="../../assets/image_guide/image3/two1.png" alt="">
            </div>
            <div>
              <img src="../../assets/image_guide/image3/two2.png" alt=""></div>
          </div>
        </div>

          <div class="rule-box">
            <header>{{ $t("gift_album_des6") }}</header>
            <p>{{ $t("gift_album_des5") }}</p>
          </div>
    </div>
  </template>
  
  <script>
    // 心动焦点
  export default {
    name: "image_guide_3",
    data() {
      return {
        client:'',
        langType:''
      };
    },
    created() {
        this.judgeClient()
        this.$completes.complete("getUserInfo");
          window.getUserInfo = this.getUserInfo
          window['getUserInfo'] = (data) => {
              this.getUserInfo(data);
        }
    },
    mounted() {
    },
    methods: { 
      returns() {
        this.$completes.complete("getPreviousPage");
      },
        // 判断平台
        judgeClient() {
          if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
              this.client = 'iOS';
          } else if (/(Android)/i.test(navigator.userAgent)) { //判断Android
              this.client = 'Android';
          } else {
              this.client = 'PC';
          }
          return this.client;
        },
        getUserInfo(data) {
          this.userInfo = JSON.parse(data);
          let langs = this.userInfo.lang.substring(0, 2)
          let lang = this.userInfo.lang
          if (langs == "zh") {
            if (lang == "zh_TW" || lang == "zh_HK") {
              this.$i18n.locale = "tc";
            } else {
              this.$i18n.locale = "zh";
            }
          } else if (langs == "en") {
            this.$i18n.locale = "en";
          } else if (langs == "ar") {
            this.$i18n.locale = "ar";
          } else if (langs == "tr") {
            this.$i18n.locale = "tr";
          } else if (langs == "es") {
            this.$i18n.locale = "es";
          } else if (langs == "pt") {
            this.$i18n.locale = "pt";
          } else if (langs == "fr") {
            this.$i18n.locale = "fr"
          } else if (langs == "id") {
            this.$i18n.locale = "id"
          } else if (langs == "ms") {
            this.$i18n.locale = "ms"
          } else {
            this.$i18n.locale = "en";
          }
          document.querySelector("html").setAttribute("lang", this.$i18n.locale);
        },
    },
  };
  </script>
  
  <style scoped>
html[lang="ar"] .imageGuideBox {
  direction: rtl;
}
html[lang="ar"] .close-box{
  left: 10px;
  right: auto;
}
html[lang="ar"] .rule-box p{
  padding-left: 0;
  padding-right: 1em;
}
html[lang="ar"] .gift-item{
  margin-right: 0;
  margin-left: 50px;
}
html[lang="ar"] .gift-item:nth-of-type(3n){
  margin-right: 0;
  margin-left: 0;
}

 html[lang="ar"] .gift-two-box div:nth-of-type(1){
    margin-right: 0px;
    margin-left: 40px;
}
  * {
    margin: 0;
    padding: 0;
  }
  .imageGuideBox{
    font-family: "Mada";
    height: 100vh;
    overflow: hidden;
    overflow-y: auto;
    background: linear-gradient(to bottom, #FF4A69, #F87A7C, #FFEFEF);
  }
.bannerBg{
  width: 100%;
  height: 400px;
  background: url("../../assets/image_guide/image3/banner-bg.png") no-repeat;
  background-size: 100% 100%;
  padding-top: 150px;
  box-sizing: border-box;
}
.bannerBg span{
  display: block;
  width: 500px;
  height: 162px;
  margin: 0 auto;
  background: url("../../assets/image_guide/image3/title_en.png") no-repeat;
  background-size: 100%;
}
html[lang="ar"] .bannerBg span{
  background: url("../../assets/image_guide/image3/title_ar.png") no-repeat;
  background-size: 100%;
}
html[lang="es"] .bannerBg span{
  background: url("../../assets/image_guide/image3/title_es.png") no-repeat;
  background-size: 100%;
}
html[lang="id"] .bannerBg span{
  background: url("../../assets/image_guide/image3/title_id.png") no-repeat;
  background-size: 100%;
}
html[lang="tr"] .bannerBg span{
  background: url("../../assets/image_guide/image3/title_tr.png") no-repeat;
  background-size: 100%;
}
.content{
  width:592px;
  margin: -80px auto 0;
}
.gift-box{
  width: 100%;
  height: 720px;
  background: url("../../assets/image_guide/image3/gift-bg.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-wrap: wrap;
  /* justify-content: space-between; */
  box-sizing: border-box;
  padding: 28px 34px 30px;
}
.gift-item{
  width: 136px;
  height: 200px;
  margin-right: 50px;
}
.gift-item:nth-of-type(3n){
  margin-right: 0;
}
.gift-item img{
  display: block;
  width: 136px;
  height: 136px;
  margin-bottom: 5px;
}
.gift-item p{
  font-size: 24px;
  line-height: 34px;
  font-weight: 400;
  text-align: center;
  color: #0F528B;
}
.giftName{
  white-space: nowrap; /* 禁止换行 */
  overflow: hidden;    /* 溢出部分隐藏 */
  text-overflow: ellipsis; /* 使用省略号表示被截断的内容 */
  width: 100%;         /* 设置一个具体的宽度或百分比 */
}
.gift-item p:nth-of-type(2){
  color: #000;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
}
.gift-item p:nth-of-type(2)::before{
  content: '';
  display: inline-block;
  width: 24px;
  height: 24px;
  background: url("../../assets/image_guide/image3/zuan.png") no-repeat;
  background-size: 100% 100%;
  margin:0 5px;
}
.gift-desc{
  font-size: 28px;
  line-height: 38px;
  font-weight: 500;
  color: #0F528B;
  text-align: center;
  margin: 16px 0;
}
.close-box{
  width: 56px;
  height: 56px;
  position: fixed;
  top: 12px;
  right: 10px;
  background: url("../../assets/image_guide/image3/close-btn.png") no-repeat;
  background-size: 100% 100%;
}
  .gift-two-box{
    width: 512px;
    height: 332px;
    margin: 0 auto;
    background: url("../../assets/image_guide/image3/gift-two-bg.png") no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .gift-two-box div:nth-of-type(1){
    margin-right: 40px;
  }
  .gift-two-box div{
    width: 214px;
    height: 284px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .gift-two-box img{
    display: block;
    width: 210px;
    height: auto;
    object-fit: contain;
  }
  .rule-box{
    padding: 0 26px;
    border-top: 1px dashed #FFFFFF;
    margin-top: 32px;
    box-sizing: border-box;
  }
  .rule-box header{
    font-family: "Oleo Script";
    font-size: 32px;
    line-height: 42px;
    font-weight: 400;
    color: #0F528B;
    margin: 20px 0;
  }
  .rule-box p{
    font-size: 28px;
    line-height: 38px;
    font-weight: 400;
    color: #0F528B;
    margin-bottom: 20px;
    text-indent: -0.8em;
    padding-left: 1em;
  }
  /* 仅针对 WebKit 浏览器 */
.hide-scrollbar::-webkit-scrollbar {
    display: none;
}
/* 隐藏整个滚动条 */
.hide-scrollbar {
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE 和 Edge */
}
  </style>
  